module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10246.f92c4055.jpg";